module.exports = __webpack_public_path__ + "img/clearance-sale.52317d88.jpg";